import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../shared/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FeatherIconModule } from '../root/feather-icon.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AboutDialog } from './about/about-dialog.component';
import { FuseAboutComponentDynamic } from './about-dynamic/about.component';
import { SLSNToolbarComponent } from './toolbar/toolbar.component';
import { FuseQuickPanelComponent } from './quick-panel/quick-panel.component';
import { NavbarVerticalStyle2Component } from './navbar/app-navbar.component';
import { AvatarModule } from 'ngx-avatars';
import { FuseNavigationModule } from './navigation/navigation.module';
import { FuseSharedModule } from '@ecap3/template-atlas';
import { NgxPullToRefreshModule } from '../shared/stubs/other-stubs.module';
import { AppSharedPipeModule } from '../app-shared-pipe/app-shared-pipe.module';

@NgModule({
    declarations: [
        AboutDialog,
        FuseAboutComponentDynamic,
        SLSNToolbarComponent,
        FuseQuickPanelComponent,
        NavbarVerticalStyle2Component
    ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        TranslateModule.forChild(),
        FeatherIconModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        AvatarModule,
        FuseNavigationModule,
        FuseSharedModule,
        NgxPullToRefreshModule,
        AppSharedPipeModule
    ],
    exports: [
        AboutDialog,
        FuseAboutComponentDynamic,
        SLSNToolbarComponent,
        FuseQuickPanelComponent,
        NavbarVerticalStyle2Component
    ]
})
export class FuseModule { }
